import { hooks, hooksInterface } from 'src/router/hooks/abstract';
import type { dynamicObj } from 'src/pages/assets';
import logger from 'src/utils/logger';
import { RouteLocationNormalized } from 'vue-router';

export default class NotFoundHook extends hooks implements hooksInterface {
  public constructor() {
    super();
  }

  public execute(to: RouteLocationNormalized, from: RouteLocationNormalized) {
    const log_info = {} as dynamicObj;
    const { fullPath, params, query } = from;

    log_info.from = {
      fullPath,
      params,
      query,
    };
    log_info.to = { fullPath: to.fullPath };
    //logger.info(log_info);
  }
}
